import i18n from "@euroland/libs/locale/i18n";
import { TableData } from "@euroland/react-table";
import Icon from "../ui/Icon";

const ProfileMarketTable = ({ body, header, caption, title }) => {
  let bodydata, bodydataName, headerName, head;
  let profileData, marketData, profileHeader, marketHeader;
  let tableCreate = {};
  
  body.map((bd) => {
    bodydata = Object.values(bd)[0];
    bodydataName = Object.keys(bd)[0];
    headerName = Object.keys(header[bodydataName])[0];
    head = header[headerName];
    if (bodydataName === "profile") {
      tableCreate.profile = "profile";
      profileData = bodydata;
      profileHeader = head[bodydataName];
    }
    if (bodydataName === "marketInfo") {
      tableCreate.marketInfo = "marketInfo";
      marketData = bodydata;
      marketHeader = head[bodydataName];
    }
    return(profileData,profileHeader,marketData,marketHeader);
  });
  return (
    <>
      {tableCreate.profile === "profile" && (
        <td className="flex-td">
          <div
            id={tableCreate.profile}
            className={tableCreate.profile.toLowerCase() + "-box-content"}
          >
            <TableData
              className="quadrata-share-data-table"
              design="table-quadrata"
              hiddenHeader={false}
              hiddenFooter={true}
              body={profileData}
              header={profileHeader}
              theadChild={
                <tr>
                  <th data-column="fieldName" scope="col">{i18n.translate("fieldName")}</th>
                  <th data-column="fieldValue" scope="col">{i18n.translate("fieldValue")}</th>
                </tr>
              }
              theadProps={{
                className: "sr-only table-header"
              }}
              headerLeft={true}
              caption={
                <p>
                  <Icon name="profile" className="profile" />
                  {title[tableCreate.profile]}
                </p>
              }
              containerProps={{}}
            ></TableData>
          </div>
        </td>
      )}
      <td className="flex-td-none"></td>
      {tableCreate.marketInfo === "marketInfo" && (
        <td className="flex-td">
          <div
            id={tableCreate.marketInfo}
            className={tableCreate.marketInfo.toLowerCase() + "-box-content"}
          >
            <TableData
              className="quadrata-share-data-table"
              design="table-quadrata"
              hiddenHeader={false}
              hiddenFooter={true}
              body={marketData}
              header={marketHeader}
              theadChild={
                <tr>
                  <th data-column="fieldName" scope="col">{i18n.translate("fieldName")}</th>
                  <th data-column="fieldValue" scope="col">{i18n.translate("fieldValue")}</th>
                </tr>
              }
              theadProps={{
                className: "sr-only table-header"
              }}
              headerLeft={true}
              caption={
                <p>
                  <Icon name="market_info" className="market_info" />
                  {title[tableCreate.marketInfo]}
                </p>
              }
              containerProps={{}}
            ></TableData>
          </div>
        </td>
      )}
    </>
  );
};
export default ProfileMarketTable;
